import React from "react";
import { Link, useLocation } from "react-router-dom";

/** Desktop nav-tabs row (Roster / Job Sites / Import). Hidden on mobile. */
export default function DesktopNav({ items }) {
  const loc = useLocation();
  if (!items?.length) return null;
  return (
    <nav className="hidden md:flex items-center gap-2">
      {items.map(({ to, label, Icon, testId }) => {
        const active = loc.pathname.startsWith(to);
        return (
          <Link
            key={to}
            to={to}
            data-testid={testId}
            className={`h-12 px-4 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider border-2 transition-colors ${
              active
                ? "bg-safety-yellow text-black border-black dark:border-safety-yellow"
                : "bg-transparent text-foreground border-transparent hover:border-foreground"
            }`}
          >
            <Icon className="w-4 h-4" strokeWidth={2.5} />
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
